/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import {
    ILoyaltyLayouts,
    IFeature,
    ISection,
    OrderConfigTuple
} from '~views/components/interfaces';

export const loadOnDemand =
    (viewFunction: Function, viewParams: IFeature | {} = {}) =>
    () =>
        React.createElement(viewFunction as any, viewParams as any);

const pad = (name: string) => [' ', name, ' '].join('');
const getMultipleSections = (sameRow: OrderConfigTuple[]) =>
    sameRow
        .map(
            ([name, section]: OrderConfigTuple) =>
                `${pad(name).repeat(section?.params?.position?.spaces)}`
        )
        .join(' ');

const getSingleSections = (components: OrderConfigTuple[]) =>
    components
        .map(([sectionName, section]) => {
            if (section.params?.position?.extend) {
                return `'${pad(sectionName)} ${pad(sectionName)} ${pad(sectionName)}'`;
            }

            return `'. ${pad(sectionName as string)} .'`;
        })
        .join('');

const sortByRowThenOrder = ([, a]: OrderConfigTuple, [, b]: OrderConfigTuple) => {
    const positionA = a?.params?.position;
    const positionB = b?.params?.position;

    return positionA?.row - positionB?.row || positionA?.order - positionB?.order;
};

export const createSingleGridLayout = (
    componentConfig: ISection['elements'] = {}
): ILoyaltyLayouts['smallLayout'] => {
    const sorted = Object.entries(componentConfig).sort(sortByRowThenOrder);

    return getSingleSections(sorted);
};

export const createMultiGridLayout = (
    componentConfig: ISection['elements'] = {}
): ILoyaltyLayouts => {
    const sorted = Object.entries(componentConfig).sort(sortByRowThenOrder);
    const smallLayout = getSingleSections(sorted);

    const largeLayout = sorted.reduce((grid, component) => {
        const [, section] = component;
        const sameRow = sorted.filter(
            ([, item]) => item?.params?.position?.row === section?.params?.position?.row
        );

        const multipleSections = getMultipleSections(sameRow);
        const hasSection = grid.includes(multipleSections);

        if (!hasSection) {
            if (section.params?.position?.extend) {
                const splitSections = multipleSections.split(' ');
                // eslint-disable-next-line no-param-reassign
                grid += `'${multipleSections.split(' ')[1]} ${multipleSections} ${
                    splitSections[splitSections.length - 2]
                }'`;
            } else {
                // eslint-disable-next-line no-param-reassign
                grid += `'. ${multipleSections} .'`;
            }
        }

        return grid;
    }, '');

    return { smallLayout, largeLayout };
};
